import { registerPendingImage } from "./pendingImages";
import { IRichTextImageAdapter, IRichTextPendingImage } from "./types";

export class StorageServiceImageAdapter implements IRichTextImageAdapter {
  readonly immediate = false;

  // Interface requires an instance method; this implementation is a
  // stateless delegate to the module-level registry.
  // eslint-disable-next-line class-methods-use-this
  async insert(image: IRichTextPendingImage): Promise<string> {
    return registerPendingImage(image);
  }
}

export const storageServiceImageAdapter = new StorageServiceImageAdapter();
